<template>
  <!-- 建筑信息 -->
  <span class="apphome">
    <el-row :gutter="10" style="width: 100%;">
      <el-col :xs="24" :sm="24" :md="24" :lg="num" :xl="num">
        <div class="apphome_box">
          <div class="search">
            <div class="left">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-document-add"
                @click="add_ed"
                style="margin-right: 20px;"
                >添加</el-button
              >
            </div>
            <div class="right">
              <span>
                <span>名称：</span>
                <el-input
                  v-model="conditions.name"
                  placeholder="请输入内容"
                  clearable
                ></el-input>
              </span>
              <span>
                <span>编号：</span>
                <el-input
                  v-model="conditions.code"
                  placeholder="请输入内容"
                  clearable
                ></el-input>
              </span>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-search"
                @click="getList"
                style="margin-right: 20px;"
                :loading="loading"
                >查询</el-button
              >
              <el-switch
                v-model="shebei"
                active-text="设备操作"
                inactive-text=""
              ></el-switch>
              <el-switch
                v-model="jianzhu"
                active-text="虚拟设备"
                inactive-text=""
              ></el-switch>
            </div>
          </div>

          <el-table
            :max-height="heights - 27"
            :header-cell-style="{
              color: '#333',
              fontFamily: 'MicrosoftYaHeiUI',
              fontSize: '14px',
              fontWeight: 900,
              backgroundColor: '#f5f7fa',
            }"
            stripe
            :data="tableData"
            border
            style="width: 100%"
          >
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据" />
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="60" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
                <!-- <span>{{ scope }}</span> -->
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in columns"
              :key="index"
              :label="item.name"
              align="center"
              :width="item.width"
            >
              <template slot-scope="{ row }">
                <el-image
                  v-if="item.key == 'buildingAppearancePhoto'"
                  style="width: 50px; height: 50px"
                  :src="row[item.key]"
                  :preview-src-list="[row.buildingAppearancePhoto]"
                >
                </el-image>
                <!--                <img src="file://D:/wedoSystem/resources/default/jpg/2022/10/09/6851ea6bbfc64fe385a79bb4726898a7/0f487f73646344876df7c32b2a100288_.jpg" />-->
                <span v-else-if="item.key == 'energyBuildingTypeId'">{{
                  optionsed[row[item.key]] || "-"
                }}</span>
                <span v-else>{{ row[item.key] || "-" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
              width="170"
              fixed="right"
            >
              <template #default="{row}">
                <span class="buttoned_box">
                  <el-link
                    type="primary"
                    class="buttoned"
                    :class="{ actived: mainId === row.id }"
                    @click="bangding(row.id)"
                  >
                    设备绑定</el-link
                  >
                  <el-link type="primary" class="buttoned" @click="edit_ed(row)"
                    >编辑</el-link
                  >
                  <el-link
                    type="primary"
                    class="buttoned"
                    @click="del_fn(row.id)"
                    >删除</el-link
                  >
                </span>
              </template>
            </el-table-column>
          </el-table>

          <span class="paginationed">
            <Pagination
              align="center"
              :total="total"
              :page-sizes="[5, 10, 15, 20, total]"
              :page.sync="listData.page"
              :limit.sync="listData.rows"
              @pagination="getList"
            />
          </span>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
        <!-- 绑定部门组织 -->
        <transition name="el-zoom-in-center">
          <!--          <div class="apphome_box" v-show="shebei">-->
          <div class="apphome_box" v-show="shebei">
            <span
              style="font-size: 16px;font-weight: bold;transform: translateY(-10px);
              display: block;"
              >绑定部门</span
            >
            <span class="search">
              <span
                style="display: flex;white-space: nowrap;align-items: center;"
              >
                <span>部门：</span>
                <el-input
                  v-model="searchName"
                  style="width: 110px;"
                  placeholder="请输入部门"
                  clearable
                ></el-input>
              </span>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getDevice"
                :loading="loading"
                >查询</el-button
              >
              <el-button type="success" @click="saveDevice">绑定</el-button>
            </span>
            <el-table
              id="demo"
              :max-height="heights - 67"
              ref="multipleTable"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange"
              :header-cell-style="{
                color: '#333',
                fontFamily: 'MicrosoftYaHeiUI',
                fontSize: '14px',
                fontWeight: 900,
                backgroundColor: '#f5f7fa',
              }"
              stripe
              :data="bumenData"
              border
              style="width: 100%"
              row-key="Id"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <template slot="empty">
                <span class="noData">
                  <img src="../../assets/noData.png" alt="暂无数据" />
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column type="selection" width="39"> </el-table-column>
              <el-table-column label="序号" width="60" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Name" label="部门" align="center">
              </el-table-column>
            </el-table>

            <span class="paginationed">
              <Pagination
                align="center"
                :total="total2"
                :page.sync="listData2.page"
                layout="prev, pager, next"
                :limit.sync="listData2.rows"
                @pagination="getDevice"
              />
            </span>
          </div>
          <!--        </div>-->
        </transition>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
        <!-- 虚拟设备 -->
        <transition name="el-zoom-in-center">
          <subareabuild
            v-if="jianzhu"
            :mainId="mainId"
            ref="child"
          ></subareabuild>
        </transition>
      </el-col>
    </el-row>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      v-dialogDrag
      :visible.sync="detail_status"
      width="400"
      center
    >
      <el-form label-width="120px" class="demo-temp">
        <el-form-item style="margin: 0;" label="父id:">
          <span>{{ temp.UpId }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="模块名:">
          <span>{{ temp.name }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="路由地址:">
          <span>{{ temp.code }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="领导:" prop="Leader">
          <span>{{ temp.Leader }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="等级:">
          <span>{{ temp.number }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="实体类型:">
          <span>{{ temp.EntityType }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="整体水平:">
          <span>{{ temp.EntityLevel }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="区域id:">
          <span>{{ temp.AreaId }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="州:">
          <span>{{ temp.State }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="排序:">
          <span>{{ temp.SerialNo }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="级别代码:">
          <span>{{ temp.LevelCode }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="版本号:">
          <span>{{ temp.VersionNum }}</span>
        </el-form-item>
        <el-form-item style="margin: 0;" label="备注:">
          <span>{{ temp.Memo }}</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="detail_status = false"
            >确 定
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 新增修改 -->
    <el-dialog
      v-dialogDrag
      :title="textMap[dialogStatus]"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="400"
      center
    >
      <el-form
        :inline="true"
        :model="temp"
        :rules="rules"
        ref="temp"
        label-width="127px"
        class="demo-temp"
      >
        <el-form-item
          v-for="(item, index) in columns"
          :key="index"
          :label="item.name"
          :prop="item.key"
        >
          <span
            v-if="item.key == 'buildingAppearancePhoto'"
            style="display: flex;align-items: center;"
            class="beijing"
          >
            <el-image
              :src="temp.buildingAppearancePhoto"
              style="width: 100px;margin-right: 15px;"
              @click="cropper_img_status = true"
            >
              <div slot="error" class="image-slot">
                <i
                  class="el-icon-plus avatar-uploader-icon"
                  @click="cropper_img_status = true"
                ></i>
              </div>
            </el-image>
          </span>
          <span v-else-if="item.key == 'coordinate'">
            <el-button type="primary" @click="openMap">地图</el-button
            ><span>{{ temp[item.key] }}</span>
          </span>
          <span v-else-if="item.key == 'energyBuildingTypeId'">
            <el-select v-model="temp[item.key]" clearable placeholder="请选择">
              <el-option
                v-for="(item, i) in options"
                :key="i"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </span>
          <el-input
            v-else
            v-model="temp[item.key]"
            :placeholder="'请输入' + item.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="dialogStatus === 'edit' ? edit_fn('temp') : add_fn('temp')"
            >确 定
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 裁剪图片 -->
    <el-dialog
      v-dialogDrag
      center
      :visible.sync="cropper_img_status"
      width="500px"
      title="上传图片"
    >
      <cropper_img :msg="temp.type" @func="get_img"></cropper_img>
    </el-dialog>

    <!-- 地图 -->
    <el-dialog
      v-dialogDrag
      center
      title="地图(点击地图选择坐标)"
      :visible.sync="mapStatus"
      :close-on-click-modal="false"
    >
      <bmap
        v-if="mapStatus"
        ref="mychild"
        :inputName="mapData"
        @func="getMsgFormSon"
      ></bmap>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mapStatus = false">取消</el-button>
        <el-button type="primary" @click="clickParent">确定</el-button>
      </div>
    </el-dialog>
    <!--    </div>-->
  </span>
</template>

<script>
import {
  findAllBuildingType,
  saveEnergyBuildingInfo,
  findBuildingByNameAndNo,
  deleteEnergyBuildingInfoById,
} from "../../api/buildingApi";
import Pagination from "../../components/module/Pagination"; // 分页
//   import { EnergyBuildingQuery, EnergyBuildingId, EnergyBuildingAdd, EnergyBuildingEdit, EnergyBuildingDelete, GetEnergyBuildingOrganization, SaveEnergyBuildingOrganization, UploadPhotosAsync, GetAndNames } from "@/utils/request";
//   import { GetBuildingByUnitIdConditions, SaveBuildingByUnitId, DeleteBuilding } from "@/utils/javaRequest";
//   import { parseTime } from "@/utils";
import bmap from "../../components/module/map/baiduMapSelect"; // 地图
import cropper_img from "../../components/module/city_picker/cropper_img"; // 裁剪图片
import subareabuild from "./subAreaBuild2"; // 绑定建筑
import resourcesStore from "@/cache/resourcesStore.js";
export default {
  components: { Pagination, cropper_img, bmap, subareabuild },
  data() {
    return {
      loading: false,
      mapData: "",
      mapStatus: false,
      cropper_img_status: false,
      img: "",
      searchName: "",
      mainId: 0,
      options: [], //建筑类型
      optionsed: {}, //建筑类型
      shebei: false,
      jianzhu: false,
      detail_status: false,
      columns: [
        {
          name: "名称",
          key: "name",
          width: 170,
        },
        {
          name: "编号",
          key: "code",
        },
        {
          name: "建筑外观图",
          key: "buildingAppearancePhoto",
          width: 120,
        },
        {
          name: "建筑类型",
          key: "energyBuildingTypeId",
          width: 120,
        },
        {
          name: "进线来源",
          key: "inlineSource",
        },
        {
          name: "进线数量",
          key: "inlineQuantity",
        },
        {
          name: "建筑面积",
          key: "buildingArea",
        },
        {
          name: "变压器数量",
          key: "transformerQuantity",
          width: 120,
        },
        {
          name: "总变压器数量KVA",
          key: "totalTransformerQuantity",
          width: 140,
        },
        {
          name: "总容量KVA",
          key: "totalCapacityKVA",
          width: 120,
        },
        {
          name: "监测点数",
          key: "monitorPoints",
        },
        {
          name: "电房数量",
          key: "electricRoomQuantity",
        },
        {
          name: "负荷容量",
          key: "burdenCapacity",
        },
        {
          name: "坐标",
          key: "coordinate",
          width: 165,
        },
        {
          name: "备注",
          key: "memo",
        },
        {
          name: "年度计划用电",
          key: "annualPlanUsePower",
        },
        {
          name: "年度计划用水",
          key: "annualPlanUseWater",
        },
        {
          name: "年度计划用气",
          key: "annualPlanUseGas",
        },
        {
          name: "建筑面积指标",
          key: "auildingAreaIndicator",
        },
        {
          name: "建筑人数",
          key: "buildingPopulation",
        },
        {
          name: "建筑人数指标",
          key: "buildingPopulationIndicator",
        },
      ],
      toggleRowData: [], //已勾选数据
      total: 0,
      listData: {
        page: 1,
        rows: 10,
      },
      total2: 0,
      listData2: {
        page: 1,
        rows: 10,
      },
      heights: document.body.clientHeight - 218,
      tableData: [],
      search: {},
      bumenData: [],
      rules: {
        name: [{ required: true, message: "请输入区域名", trigger: "blur" }],
        code: [{ required: true, message: "请输入区域代码", trigger: "blur" }],
      },
      conditions: {},
      temp: {},
      dialogVisible: false,
      dialogStatus: "",
      textMap: {
        add: "新增",
        edit: "编辑",
      },
    };
  },
  computed: {
    getResourcesByName() {
      return resourcesStore.getters.getResourcesByName;
    },
    num: function() {
      if (this.shebei && this.jianzhu) {
        return 12;
      } else if (this.shebei || this.jianzhu) {
        return 18;
      } else {
        return 24;
      }
    },
    nowUnit: function() {
      // return this.$store.state.settings.count;
      return 0;
    },
  },
  watch: {
    nowUnit(val) {},
  },
  mounted() {
    findAllBuildingType().then((res) => {
      if (res.success) {
        this.options = res.data;
        // console.log("this.options",this.options);
        // console.log(" this.options", this.options);
        this.options.map((v) => {
          this.optionsed[v.id] = v.name;
        });
        this.getList();
      }
    });
    // this.$refs.multipleTable.toggleRowSelection(this.tableData[1]);
  },
  methods: {
    //获取子组件数据
    getMsgFormSon(data) {
      if (data.lat) {
        this.$set(this.temp, "coordinate", data.lng + "," + data.lat);
      }
      this.mapStatus = false;
    },
    //调用子组件方法
    clickParent() {
      this.$refs.mychild.sendMsg();
    },
    // 打开地图
    openMap() {
      this.mapData = this.temp.coordinate;
      this.mapStatus = true;
    },
    // 获取裁剪好的图片
    get_img(v) {
      this.$set(this.temp, "buildingAppearancePhoto", v);
      this.cropper_img_status = false;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handlePreview(file) {
      //上传图片
      let formData = new FormData();
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return;
      }
      formData.append("files", file.raw);
      this.$set(
        this.temp,
        "buildingAppearancePhoto",
        window.URL.createObjectURL(file.raw)
      );
    },
    // 绑定
    saveDevice() {
      var d = {
        mainId: this.mainId,
        selectOptions: [],
      };
      this.toggleRowData.map((v) => {
        v.map((a) => {
          d.selectOptions.push(a.Id);
        });
      });

      SaveEnergyBuildingOrganization(d).then((res) => {
        if (res.Success) {
          this.toggleRowData = [];
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "success",
            duration: 5 * 1000,
          });
        }
      });
    },

    // 绑定设备
    bangding(id) {
      this.jianzhu = true;
      this.toggleRowData = [];
      this.mainId = id;
      //this.getDevice();
      if (this.$refs.child) {
        this.$refs.child.childMethod(this.mainId);
      }
    },
    //获取组织
    getDevice() {
      //this.shebei = true;
      this.jianzhu = true;
      var d = {
        mainId: this.mainId,
        pageParam: {
          page: this.listData2.page,
          rows: this.listData2.rows,
        },
      };
      if (this.searchName) {
        d.pageParam.conditions = [
          { field: "Name", symbol: "like", value: this.searchName.trim() },
        ];
      }
      this.loading = true;
      GetEnergyBuildingOrganization(d).then((res) => {
        this.loading = false;
        if (res.Success) {
          this.bumenData = res.Response.PageData.data;
          this.total2 = res.Response.PageData.dataCount;

          var d = res.Response.MultipleSelectOption.SelectOptions;
          setTimeout(() => {
            d.map((v) => {
              this.bumenData.map((a, i) => {
                if (a.Id == v.Id) {
                  this.$refs.multipleTable.toggleRowSelection(
                    this.bumenData[i],
                    true
                  );
                }
              });
            });
          }, 100);

          //每页勾选
          if (this.toggleRowData[this.listData2.page - 1]) {
            setTimeout(() => {
              this.toggleRowData[this.listData2.page - 1].map((v) => {
                this.bumenData.map((a, i) => {
                  if (a.Id == v.Id) {
                    this.$refs.multipleTable.toggleRowSelection(
                      this.bumenData[i],
                      true
                    );
                  }
                });
              });
            }, 100);
          }
        }
      });
    },
    //删除
    del_fn(id) {
      this.$confirm("是否删除此建筑", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let d = {
            id: id,
          };
          deleteEnergyBuildingInfoById(d).then((res) => {
            if (res.code == 200) {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
              this.getList();
              var bool = this.$store.unitStore.state.buildingNum;
              this.$store.unitStore.commit("setBuildingNum", !bool);
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {
          // ...
        });
    },
    // 勾选
    handleSelectionChange(val) {
      this.toggleRowData[this.listData.page - 1] = val;
    },
    // 获取绑定列表
    getList() {
      this.tableData = [];
      let d = {
        //"unitId": this.nowUnit,
        pageIndex: this.listData.page,
        pageSize: this.listData.rows,
        // "name": this.conditions.Name,
        // "code": this.conditions.Code,
        name: this.conditions.name,
        code: this.conditions.code,
      };
      this.loading = true;

      // var star = (this.listData.page - 1) * this.listData.rows
      // var end = this.listData.rows + star > this.total ?  this.total : this.listData.rows + star
      // for(let i = star;i<end;i++){
      //   this.tableData.push(abc.data[i])
      // }

      findBuildingByNameAndNo(d).then((res) => {
        this.loading = false;
        this.tableData = res.data.content;
        this.total = res.data.numberOfElements;
      });
    },

    // 添加弹窗
    add_ed() {
      this.dialogStatus = "add";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["temp"].clearValidate();
      });

      this.temp = {};
    },
    // 确认添加
    add_fn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.temp.unitId = this.nowUnit;
          saveEnergyBuildingInfo(this.temp).then((res) => {
            if (res && res.code == 200) {
              this.getList();
              this.dialogVisible = false;
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
              var bool = this.$store.unitStore.state.buildingNum;
              this.$store.unitStore.commit("setBuildingNum", !bool);
            } else {
              this.$message.error("添加失败");
            }
          });
        } else {
          return false;
        }
      });
    },

    // 确认编辑
    edit_fn() {
      this.$refs["temp"].validate((valid) => {
        if (valid) {
          // EnergyBuildingEdit(this.temp).then(data => {
          //   if (data.Success) {
          //     this.getList();
          //     this.dialogVisible = false;
          //     this.$message({ showClose: true, message: '修改成功', type: 'success' });
          //   } else {
          //     data.Msg ? this.$message.error(data.Msg) : this.$message.error('修改失败');
          //   }
          //
          // })
          //this.temp.unitId = this.nowUnit;
          this.temp.uId = this.temp.id;
          delete this.temp.id;

          saveEnergyBuildingInfo(this.temp).then((res) => {
            if (res.code == 200) {
              this.getList();
              this.dialogVisible = false;
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
            } else {
              this.$message.error("修改失败");
            }
            // if(res && res.success) {
            //   this.getList();
            //   this.dialogVisible = false;
            //   this.$message({ showClose: true, message: '修改成功', type: 'success'});
            // }else {
            //   this.$message.error("修改失败");
            // }
          });
        } else {
          return false;
        }
      });
    },
    //编辑弹窗
    edit_ed(v) {
      this.dialogStatus = "edit";
      this.temp = Object.assign({}, v);

      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["temp"].clearValidate();
      });
    },
  },
};
</script>
<style></style>
<style lang="scss" scoped>
.apphome {
  padding: 10px;
}

.apphome_box {
  margin-bottom: 50px;
  background-color: #fff;
  padding: 10px;
}

.actived {
  color: red;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d7d7d7;
  border-radius: 4px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.buttoned_box {
  display: flex;
  justify-content: space-around;

  .buttoned {
    cursor: pointer;
  }
}

.search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;

  .right {
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > span {
      display: flex;
      white-space: nowrap;
      align-items: center;
      margin-right: 10px;
    }

    input {
      width: 110px;
    }
  }
}
</style>
